var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"filter-cog-btn",attrs:{"icon-left":"filter","disabled":_vm.isDisabled,"visible":_vm.isVisible},on:{"click":function($event){return _vm.$emit('onClick')}}})}
var staticRenderFns = []

export { render, staticRenderFns }